module.exports = __webpack_public_path__ + "static/media/promo_pop_rock.b44ce2cf.webp";